import { getActivityText } from '../../../../common/helpers/titles';

export const mapActivitiesRowData = (agentsRowData = [], activities = []) => {
  if (!agentsRowData.length || !activities.length) return [];

  const agentMap = new Map(agentsRowData.map(agent => [agent.agentId, agent]));
  const validActivities = activities.filter(activity => agentMap.has(activity.agentId));
  validActivities.sort(
    (a, b) => new Date(b.activityDate).getTime() - new Date(a.activityDate).getTime()
  );

  return validActivities.map((activity, index) => {
    const agent = agentMap.get(activity.agentId);

    return {
      ...agent,
      rank: index + 1,
      agentId: agent.agentId,
      agentName: agent.agentName,
      officeName: activity.officeName || agent.officeName,
      favorite: agent.favorite,
      activity: getActivityText(activity),
      date: activity.activityDate,
      listVolume: agent.listVolume,
      sellVolume: agent.sellVolume,
      totalVolume: agent.totalVolume,
    };
  });
};
